import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const EmpatheticIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M2 7.30545C2 4.37533 4.15007 2 6.80232 2C8.28969 2 9.61911 2.74701 10.5 3.91997C11.3809 2.74701 12.7103 2 14.1977 2C16.8499 2 19 4.37533 19 7.30546C19 8.91526 18.351 10.3576 17.3264 11.3306L11.033 17.7693C10.7324 18.0769 10.2682 18.0769 9.96759 17.7693L3.6821 11.3386C2.65254 10.3656 2 8.91968 2 7.30545Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
